import { renderToString } from 'react-dom/server';
import { Graph } from 'schema-dts';
import { NewHomesFaqContent } from '../components/NewHomesFaq/newHomesFaqContent';

export const getNewHomesGoogleSchema = (faqData: NewHomesFaqContent) => {
    const graph: Graph = {
        '@context': 'https://schema.org',
        '@graph': [
            {
                '@type': 'FAQPage',
                mainEntity: faqData.map(({ label, component }) => ({
                    '@type': 'Question',
                    name: label,
                    acceptedAnswer: {
                        '@type': 'Answer',
                        text: renderToString(component)
                    }
                }))
            }
        ]
    };

    return JSON.stringify(graph);
};
